var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeIntelligence503Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 257.758,
    height: 257.758,
    viewBox: "0 0 257.758 257.758",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H257.758V257.758H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.578,110.4H13.74A10.771,10.771,0,0,0,3,121.139v64.439a10.771,10.771,0,0,0,10.74,10.74H185.578a10.772,10.772,0,0,0,10.74-10.74V121.139A10.771,10.771,0,0,0,185.578,110.4ZM45.96,174.839a21.48,21.48,0,1,1,21.48-21.48A21.543,21.543,0,0,1,45.96,174.839ZM185.578,3H13.74A10.771,10.771,0,0,0,3,13.74V78.179a10.771,10.771,0,0,0,10.74,10.74H185.578a10.771,10.771,0,0,0,10.74-10.74V13.74A10.771,10.771,0,0,0,185.578,3ZM45.96,67.439a21.48,21.48,0,1,1,21.48-21.48A21.543,21.543,0,0,1,45.96,67.439Z",
    transform: "translate(29.22 29.22)",
    fill: "#757575"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIntelligence503Icon);
export default __webpack_public_path__ + "static/media/TimeIntelligence_503_Icon.40a45b42.svg";
export { ForwardRef as ReactComponent };